import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable({
  providedIn: 'root',
})
export class RefrigeratedTruckDataGridService {
  refrigeratedTruck: any;
  event: any;

  editRefrigeratedTruck = new Subject<[any, any]>();
  editRefrigeratedTruckData$ = this.editRefrigeratedTruck.asObservable();

  deleteRefrigeratedTruck = new Subject<[any]>();
  deleteRefrigeratedData$ = this.deleteRefrigeratedTruck.asObservable();

  constructor(private AdministratorFacade: AdministratorFacade, private swalService: SwalService) {}

  getRefrigeratedTruckDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Code',
      headerName: 'Code',
      field: 'code',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      filter: 'agTextColumnFilter',
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.textDecoration = 'underline';
        const showEdit = this.isAccess() ? this.isAccess().isEdit : true;
        if (showEdit) {
          cellElement.style.cursor = 'pointer';
        }
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const showEdit = this.isAccess() ? this.isAccess().isEdit : true;
          if (showEdit) {
            this.editRefrigeratedTruck.next([params.data.id, 'Review refrigerated truck detail']);
          }
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Refrigerated truck',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showCopy: false,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        deleteData: (data: any) => {
          this.deleteConfirmation(data);
        },
        editData: (data: any) => {
          this.editRefrigeratedTruck.next([data.id, 'Review refrigerated truck detail']);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
      filter: 'agTextColumnFilter',
    });
    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.DataManageProcessingDataRefrigeratedTruck,
      subModuleName.ProcessingDataModule
    );
  };

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getRefrigeratedTruckDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.refrigeratedTruck = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'code',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteRefrigeratedTruck.next([data]);
      }
    });
  }
}
